/* eslint-disable perfectionist/sort-objects */
import { createTheme } from "@mui/material";

export const theme = createTheme({
  breakpoints: {
    values: {
      mobile: 0,
      tablet: 768,
      desktop: 1070,
      mediumDesktop: 1280,
      largeDesktop: 1440,
      xLargeDesktop: 1560,
    },
  },
});
